import {
	btn,
	Button,
	comp,
	Component,
	cookies,
	fieldset,
	form,
	Notifier,
	router,
	tbar,
	textfield
} from "@intermesh/goui";
import {ServerApi} from "./util/ServerApi.js";
import {t} from "./util/Translate.js";
import {PasswordResetDialog} from "./PasswordResetDialog.js";
import {ServiceMessages} from "./components/ServiceMessages.js";
import {CurrentUser} from "./services/CurrentUser.js";

export class Login extends Component {

	private readonly rescueBtn: Button;
	private readonly ssoBtn: Button;

	constructor() {
		super("section");
		this.itemId = "ifw-login";
		this.id = "ifw-login";
		this.cls = "card";

		const mql = window.matchMedia("(max-width: 600px)");
		const pc = JSON.parse(localStorage.getItem("portalConfig")!);

		const f = form({
				handler: async () => {
					const v = f.value;
					const url = ServerApi.url('auth', {returnProperties: '*,user[*,groups[id,name]]'});
					ServerApi.call(url, {username: v.username, password: v.password}, "POST")
						.then(async (result) => {
							if (!result.success) {
								Notifier.error(t(result.message));
								return;
							}
							cookies.set("accessToken", result.data.accessToken, (24 * 60 * 60), "/")
							await CurrentUser.readIf();

							if (CurrentUser.hasModule("Messaging", "Instructiefilm")) {
								// const sm = new ServiceMessages();
								// await sm.load();
								// await sm.showAutomaticPopups();
							}

							if (pc.mayUseEva) {
								let evaId = sessionStorage.getItem("evaId");
								if (evaId) {
									ServerApi.call('eva/evauser/' + result.data.userId, {}, "GET")
										.then(async (evaUserResult) => {
											if (evaUserResult.data.evaId !== evaId) {
												ServerApi.call('eva/update/' + result.data.userId, {
													userId: result.data.userId,
													evaId: evaId
												}, 'POST');
											}
										})
										.catch((e) => {
											ServerApi.call('eva/create', {
												userId: result.data.userId,
												evaId: evaId
											}, 'POST');
										});
								}
							}

							CurrentUser.forcePasswordChangePopupCheck(v.password);

							// In case a user needs to log in prior to go to their actual route...
							let r = "profile";
							if (sessionStorage.getItem("routeBeforeAuth")) {
								r = sessionStorage.getItem("routeBeforeAuth")!;
								sessionStorage.removeItem("routeBeforeAuth");
							}
							void router.goto(r);

						})
						.catch((e) => {
							if (e.status && e.status == 401) {
								if(e.data.message) {
									Notifier.error(t(e.data.message));
								} else {
									Notifier.error(t("You entered an incorrect username or password"));
								}
							} else {
								console.error(e);
								Notifier.error(t("Unknown error"));
							}
						});
				}
			},

			fieldset({},
				comp({
						tagName: "div",
						cls: "ifw-title-cnt"
					},
					comp({
						tagName: "h3",
						cls: "ifw-title",
						text: t("Login") + " " + pc.title
					}),
					comp({
						tagName: "p",
						cls: "ifw-subtitle",
						text: t("Please enter your username and password"),
						hidden: pc.mayUseOauth
					}),
				),
				textfield({
					label: t("Username"),
					name: "username",
					id: "username",
					required: true,
					icon: "person",
					autocomplete: "off"
				}),
				textfield({
					label: t("Password"),
					name: "password",
					id: "password",
					type: "password",
					required: true,
					autocomplete: "off",
					icon: "lock"
				})
			),
			tbar({cls: "ifw-bbar"},
				btn({
						handler: () => {
							router.goto("");
						},
						html: t("Back")
					}
				),
				"->",

				this.ssoBtn = btn({
					handler: () => {
						window.location.href = ServerApi.url('oauth/signin', {}, true);
					},
					hidden: !pc.mayUseOauth,
					style: {
						minWidth: "40px"
					},
					// The icon will not render on this button Y THO?
					// icon: (mql.matches ? "star" : undefined),
					// html: (mql.matches ? "" : t("Login") + " " + t("via") + " Heineken"), // Eew
					html: t("Login") + " " + t("via") + " Heineken", // Eew
					title: t("Login")+ " " + t("via") + " Heineken",
					cls: "filled"
				}),

				this.rescueBtn = btn({
						handler: () => {
							const dlg = new PasswordResetDialog();
							dlg.on("close", async () => {
								console.log("Password reset dialog closed");
							});
							dlg.show();
						},
						html: (mql.matches ? "" : t("Forgot username or password?")),
						icon: (mql.matches ? "help_center" : ""),
						cls: "filled",
					}
				),
				btn({
					type: "submit",
					html: t("Login")
				})
			)
		);
		this.items.add(f);

		mql.addEventListener("change", (e: MediaQueryListEvent) => {
			this.rescueBtn.html = (e.matches ? "" : t("Forgot username or password?"));
			this.rescueBtn.icon = (e.matches ? "help_center" : "");
			if (!this.ssoBtn.hidden) {
				// this.ssoBtn.html = (e.matches ? "" : t("Login") + " " + t("via") + " Heineken");
				// this.ssoBtn.icon = (e.matches ? "star" : undefined);
			}
		});
	}
}
